<template>
    <div data-test-view="goal-feed">
        <l-card-content>
            <!-- Header -->
            <l-headline :title="headline.title" :title-popover="headline.popover" :tabs="tabs" />
            <!--/Header -->

            <l-goal-filters />

            <l-space :size="2" />

            <!-- Feed -->
            <div>
                <l-no-data
                    v-show="!goalFeed.length"
                    :text="$t(`goals.list.listEmptyH1`)"
                    :icon="iconNoData"
                    data-test-id="goals-feed-no-data"
                />

                <div v-for="feedItem in goalFeed" v-show="goalFeed.length" :key="feedItem._id">
                    <l-goal-feed-item :feed-item="feedItem" />
                    <hr />
                </div>
            </div>
            <!--/Feed -->
        </l-card-content>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getListSegment, getListCustomFilter } from "@/utils/parse-goals-query";

import LCardContent from "@/components/LCardContent";
import LGoalFeedItem from "@/components/LGoalFeedItem";
import LHeadline from "@/components/LHeadline";
import LNoData from "@/components/LNoData";
import LGoalFilters from "@/components/LGoalFilters";

import iconNoData from "@/img/icons/news.png";
import LSpace from "@/components/LSpace.vue";

export default {
    components: {
        LCardContent,
        LGoalFeedItem,
        LHeadline,
        LNoData,
        LGoalFilters,
        LSpace,
    },
    props: {
        segment: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showMenu: true,
        };
    },
    computed: {
        ...mapGetters({
            rights: "users/current/rights",
            goalFeed: "goals/goals/feed",
        }),
        tabs() {
            return [
                {
                    show: this.showMenu,
                    label: this.$t(`goals.list.hideMenu`),
                    icon: "fal fa-arrow-alt-to-left",
                    iconBeforeLabel: true,
                    testId: "goals-tree-hide-menu",
                    handler: this.toggleMenu,
                },
                {
                    show: !this.showMenu,
                    label: this.$t(`goals.list.showMenu`),
                    icon: "fal fa-arrow-alt-to-right",
                    iconBeforeLabel: true,
                    testId: "goals-tree-hide-menu",
                    handler: this.toggleMenu,
                },
                {
                    label: this.$t(`goals.list.btnExport`),
                    handler: () => this.exportGoalsList(),
                    show: true,
                    testId: "goals-export-btn",
                },
                {
                    tabClass: "space",
                    show: true,
                },
                {
                    label: this.$t(`goals.list.btnCreate`),
                    handler: () => this.createNewGoal(),
                    show: true,
                    isButton: true,
                    tabClass: "btn-primary",
                },
            ];
        },
        headline() {
            switch (this.segment) {
                case "user":
                    return {
                        title: this.$t(`goals.list.titleMyGoals`),
                        popover: this.$t(`goals.list.subtitleMyGoals`),
                    };
                case "team":
                    return {
                        title: this.$t(`goals.list.titleMyTeam`),
                        popover: this.$t(`goals.list.subtitleMyTeam`),
                    };
                case "company":
                    return {
                        title: this.$t(`goals.list.titleCompanyTeam`),
                    };
                case "all":
                default:
                    return {
                        title: this.$t(`goals.list.titleCustomSelection`),
                    };
            }
        },
    },
    created() {
        this.$emit("section", "feed");

        this.iconNoData = iconNoData;
    },
    methods: {
        async exportGoalsList() {
            await this.$store.dispatch({
                type: "goals/goals/export",
                payload: {
                    listSegment: getListSegment(this.segment),
                    listCustomFilter: getListCustomFilter(this.$route.query),
                },
            });
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
            this.$emit("toggleMenu");
        },
        createNewGoal() {
            this.$emit("create");
        },
    },
};
</script>

<style scoped></style>
